import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import SelectCompany from "../../../../components/selects/SelectCompany";
import SelectMultiCategoryFertilizers from "../../../../components/selects/SelectMultiCategoryFertilizers";

interface IProps {
  formField: any;
  form: any;
  onReset: () => void;
  onSearch: () => void;
}

export const FilterCompanyWarehouses = (props: IProps) => {
  const { t } = useTranslation();

  return (
	<Form form={ props.form } layout='vertical'>
	  <Row gutter={ 16 }>
		<Col span={ 4 }>
		  <Form.Item label={ t('chemicalization.company_warehouses.warehouse_name') } name={ props.formField.warehouseName }>
			<Input autoComplete="off"/>
		  </Form.Item>
		</Col>
		<Col span={ 4 }>
		  <Form.Item label={ t('titles.company') } name={ props.formField.companyId }>
			<SelectCompany/>
		  </Form.Item>
		</Col>
		<Col span={ 6 }>
		  <div style={ { marginTop: 30 } }>
			<Button
			  type="primary"
			  shape="default"
			  size="middle"
			  icon={ <SearchOutlined/> }
			  onClick={ props.onSearch }
			>
			  { t('general.search') }
			</Button>
			<Button size="small" type="link" onClick={ props.onReset } style={ { color: 'orange' } }>
			  { t('general.reset') }
			</Button>
		  </div>
		</Col>
	  </Row>
	</Form>
  )
}
